import React, { useEffect, useState } from 'react';
import '../styles/Perfil.css';
import PerfilOpt from '../components/OpcoesPerfil/PerfilOpt';
import Configuracoes from '../components/OpcoesPerfil/Configuracoes';
import Privacidade from '../components/OpcoesPerfil/Privacidade';
import Seguranca from '../components/OpcoesPerfil/Seguranca';
import bgShapes from '../assets/BG-shapes-1.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faCogs, faLock, faShieldAlt, faUser } from '@fortawesome/free-solid-svg-icons';

const profilePages = [
    { id: 'PerfilOpt', label: 'Perfil', icon: faUser },
    { id: 'Seguranca', label: 'Segurança', icon: faLock },
    { id: 'Configuracoes', label: 'Configurações', icon: faCogs },
    { id: 'Privacidade', label: 'Privacidade', icon: faShieldAlt },
];

const Perfil = () => {
    const [activePage, setActivePage] = useState('PerfilOpt');
    const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 520);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth <= 520);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className='main-container-perfil'>
            <img className='bgshapes' src={bgShapes} alt="bgShapes" />
            <div className='container-perfil'>
                <div className='container-esquerdo'>
                    <div className='perfil-menu-header'>
                        <span>Conta</span>
                        <strong>Preferências</strong>
                    </div>

                    <div className='perfil-menu-list'>
                        {profilePages.map((page) => (
                            <button
                                key={page.id}
                                className={`btn-esq-perfil ${activePage === page.id ? 'active' : ''}`}
                                onClick={() => setActivePage(page.id)}
                                title={isMobileView ? page.label : undefined}
                            >
                                <span className='perfil-menu-icon'>
                                    <FontAwesomeIcon icon={page.icon} />
                                </span>
                                {!isMobileView && <span>{page.label}</span>}
                                {!isMobileView && <FontAwesomeIcon className='perfil-menu-arrow' icon={faChevronRight} />}
                            </button>
                        ))}
                    </div>
                </div>

                <div className='container-direito'>
                    {activePage === 'PerfilOpt' && <PerfilOpt />}
                    {activePage === 'Seguranca' && <Seguranca />}
                    {activePage === 'Configuracoes' && <Configuracoes />}
                    {activePage === 'Privacidade' && <Privacidade />}
                </div>
            </div>
        </div>
    );
};

export default Perfil;
